import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, CLIENT_ID, SECRET_KEY } from "./urls";
import Cookies from "js-cookie";
const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers) => {
    headers.set("clientid", CLIENT_ID);
    headers.set("secretkey", SECRET_KEY);
    const token = Cookies.get("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});
export default baseQuery;
